import React from "react";

import { type RouteConfig } from "@/routes/routes";
import {
  MEDIAS,
  MYM_CLOUD,
  MYM_CLOUD_COLLECTION
} from "@/shared/constants/routes";

const MymCloud = React.lazy(() => import("@/shared/pages/mym-cloud/MymCloud"));

const MymCloudCollection = React.lazy(
  () => import("@/shared/pages/collection/Collection")
);

const Medias = React.lazy(() => import("@/shared/pages/medias/Medias"));

export const routes: RouteConfig[] = [
  {
    path: MYM_CLOUD,
    element: <MymCloud />,
    isPrivate: true
  },
  {
    path: MYM_CLOUD_COLLECTION,
    element: <MymCloudCollection />,
    isPrivate: true
  },
  {
    path: MEDIAS,
    element: <Medias />,
    isPrivate: true
  }
];
